export default "__VITE_ASSET__vYB_ijiI__"